import React, { useState } from 'react';
export function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // This is a mockup, so we don't actually do anything with the form data
    alert('Dies ist nur ein Mockup. Der Login hat keine Funktion.');
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-581">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-582">
        <div className="flex justify-center" data-id="element-583">
          <span className="text-blue-600 font-bold text-2xl" data-id="element-584">neocube</span>
          <span className="text-gray-600 text-2xl" data-id="element-585">.pro</span>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-586">
          Auditor-Login
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-587">
          Bitte melden Sie sich mit Ihren Zugangsdaten an
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-588">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-589">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-590">
            <div data-id="element-591">
              <label htmlFor="username" className="block text-sm font-medium text-gray-700" data-id="element-592">
                Benutzername
              </label>
              <div className="mt-1" data-id="element-593">
                <input id="username" name="username" type="text" required value={username} onChange={e => setUsername(e.target.value)} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-594" />
              </div>
            </div>
            <div data-id="element-595">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-596">
                Passwort
              </label>
              <div className="mt-1" data-id="element-597">
                <input id="password" name="password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-598" />
              </div>
            </div>
            <div data-id="element-599">
              <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-600">
                Anmelden
              </button>
            </div>
          </form>
          <div className="mt-6" data-id="element-601">
            <div className="relative" data-id="element-602">
              <div className="absolute inset-0 flex items-center" data-id="element-603">
                <div className="w-full border-t border-gray-300" data-id="element-604" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-605">
                <span className="px-2 bg-white text-gray-500" data-id="element-606">
                  Oder anmelden mit
                </span>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-607">
              <div data-id="element-608">
                <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-609">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-610">
                    <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z" data-id="element-611" />
                  </svg>
                  <span className="ml-2" data-id="element-612">Google</span>
                </a>
              </div>
              <div data-id="element-613">
                <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-614">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-615">
                    <path d="M0 12C0 5.373 5.373 0 12 0c4.873 0 9.067 2.904 10.947 7.077l-15.87.03a2.853 2.853 0 0 0-2.922 2.77L4.075 21.18A11.965 11.965 0 0 1 0 12zm12.862-10.272A12.05 12.05 0 0 1 24 12c0 6.627-5.373 12-12 12-5.06 0-9.399-3.12-11.174-7.537l15.786.046c1.742.005 3.23-1.419 3.296-3.16l.15-11.62z" data-id="element-616" />
                  </svg>
                  <span className="ml-2" data-id="element-617">Microsoft</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}